<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :btnsave="false"
    :title="organisasi && organisasi.organisasi_id ? 'Ubah Data Organisasi' : 'Tambah Data Organisasi'"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="8" lg="8" xl="8">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row wrap>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12">
                <v-stepper v-model="e1">
                  <v-stepper-header>
                    <v-stepper-step :complete="e1 > 1" step="1">Identitas Organisasi</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="e1 > 2" step="2">Info Tambahan</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="e1 > 3" step="3">Info Berlangganan</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="4">Konfirmasi</v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-row class="mt-2" wrap justify-center>
                        <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="py-0">
                          <label class="caption mb-2">Nama Organisasi</label>
                          <v-text-field
                            autofocus
                            dense
                            single-line
                            outlined
                            label="Nama Organisasi*"
                            name="Nama"
                            id="Nama"
                            v-model="organisasi.nama"
                            hint="Masukkan Nama Organisasi"
                            data-vv-name="nama"
                            data-vv-as="Nama Organisasi"
                            v-validate="'required|min:3|max:50'"
                            :error-messages="errors.collect('form.nama')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="py-0">
                          <label class="caption mb-2">Surel</label>
                          <v-text-field
                            dense
                            single-line
                            outlined
                            label="Surel*"
                            name="Surel"
                            id="Surel"
                            v-model="organisasi.email"
                            hint="Masukkan Surel"
                            data-vv-name="email"
                            data-vv-as="Surel"
                            v-validate="'email'"
                            :error-messages="errors.collect('form.email')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="py-0">
                          <label class="caption mb-2">Nomor Telp</label>
                          <v-text-field
                            dense
                            single-line
                            outlined
                            label="Nomor Telp"
                            name="Nomor Telp"
                            id="Nomor Telp"
                            v-model="organisasi.no_telp"
                            hint="Nomor Telepon"
                            data-vv-name="no_telp"
                            data-vv-as="Nomor Telp"
                            v-validate="'min:6|max:14|numeric'"
                            :error-messages="errors.collect('form.no_telp')"
                            :autocomplete="false"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="py-0">
                          <label class="caption mb-2">Faximile</label>
                          <v-text-field
                            dense
                            single-line
                            outlined
                            label="Faximile"
                            name="Faximile"
                            id="Faximile"
                            v-model="organisasi.fax"
                            hint="Faximile"
                            data-vv-name="fax"
                            data-vv-as="Faximile"
                            v-validate="'min:6|max:15'"
                            prefix
                            :error-messages="errors.collect('form.fax')"
                            :autocomplete="false"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="py-0">
                          <label class="caption mb-2">Alamat</label>
                          <v-textarea
                            dense
                            single-line
                            outlined
                            label="Alamat"
                            id="Alamat"
                            name="Alamat"
                            v-model="organisasi.alamat"
                            hint="Alamat"
                            data-vv-name="alamat"
                            data-vv-as="Alamat"
                            v-validate
                            rows="2"
                            :error-messages="errors.collect('form.alamat')"
                          ></v-textarea>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="py-0">
                          <label class="caption mb-2">Latitude</label>
                          <v-text-field
                            dense
                            single-line
                            outlined
                            label="Latitude"
                            name="Latitude"
                            id="latitude"
                            v-model="organisasi.latitude"
                            hint="Latitude"
                            data-vv-name="latitude"
                            data-vv-as="Latitude"
                            v-validate="'required'"
                            prefix
                            :error-messages="errors.collect('form.latitude')"
                            :autocomplete="false"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="py-0">
                          <label class="caption mb-2">Longitude</label>
                          <v-text-field
                            dense
                            single-line
                            outlined
                            label="Longitude"
                            name="Longitude"
                            id="Longitude"
                            v-model="organisasi.longitude"
                            hint="Longitude"
                            data-vv-name="longitude"
                            data-vv-as="Longitude"
                            v-validate="'required'"
                            prefix
                            :error-messages="errors.collect('form.longitude')"
                            :autocomplete="false"
                          ></v-text-field>
                        </v-col>-->

                        <v-col align="end">
                          <v-btn depressed color="primary" @click="validasiStep(2)">
                            Lanjut
                            <v-icon>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                      <v-row wrap>
                        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <v-alert text dense color="blue" icon="mdi-information-outline" border="left">
                            Opsional, diisi jika Anda ingin menambahkan identitas kegiatan lain seperti alamat, status
                            kegiatan, serta informasi lain yang ingin Anda informasikan kepada anggota instansi.
                          </v-alert>
                          <v-row wrap v-for="(item, index) in arrayAtribut" :key="item.id">
                            <v-col cols="12" sm="5" md="5" lg="5" xl="5" class="py-0">
                              <label class="caption mb-2">Nama Atribut Organisasi</label>
                              <v-text-field
                                dense
                                single-line
                                outlined
                                label="Nama Atribut Organisasi"
                                hint="Masukkan Nama Atribut Organisasi"
                                v-model="item.key"
                                data-vv-name="default_value"
                                data-vv-as="default_value"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="5" md="5" lg="5" xl="5" class="py-0">
                              <label class="caption mb-2">Isi Atribut Organisasi</label>
                              <v-text-field
                                dense
                                single-line
                                outlined
                                label="Isi Atribut Organisasi"
                                hint="Masukkan value yang diinginkan, tekan enter untuk menambahkan value baru"
                                v-model="item.value"
                                @keyup.enter="add(arrayAtribut.length)"
                                data-vv-name="default_value"
                                data-vv-as="default_value"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                              <v-btn depressed fab small color="error" @click="remove(index)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <div class="text-left mt-1">
                            <v-btn depressed color="blue" dark @click="add(arrayAtribut.length)">
                              <v-icon>mdi-plus</v-icon>Informasi Tambahan
                            </v-btn>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="d-flex justify-space-between mt-5">
                          <v-btn depressed text color="primary" @click="e1 = 1">Kembali</v-btn>&nbsp;
                          <v-btn depressed color="primary darken-1" @click="e1 = 3">
                            Lanjut
                            <v-icon>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                      <v-row wrap v-if="e1 === 3" class="mt-2">
                        <template v-if="current_user.is_super_admin === 1">
                          <v-col cols="12" sm="12" md="12">
                            <v-alert text dense color="blue" icon="mdi-information-outline" border="left">
                              Silakan mengisikan <b>jumlah kuota</b> (user) yang ada pada organisasi tersebut, termasuk
                              <b>tanggal mulai dan berakhir</b> (Pastikan sama dengan kontrak Tim Bisnis)
                            </v-alert>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                            <label class="caption">Tanggal Mulai</label>
                            <m-datepicker
                              dense
                              single-line
                              outlined
                              label="Tanggal Mulai*"
                              v-model="organisasi.tgl_berlaku_awal"
                              hint="Tanggal Mulai"
                              data-vv-name="tgl_berlaku_awal"
                              data-vv-as="Tanggal Mulai"
                              v-validate="'required'"
                              :error-messages="errors.collect('form.tgl_berlaku_awal')"
                            ></m-datepicker>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                            <label class="caption">Tanggal Selesai</label>
                            <m-datepicker
                              dense
                              single-line
                              outlined
                              autofocus
                              label="Tanggal Selesai*"
                              v-model="organisasi.tgl_berlaku_akhir"
                              hint="Tanggal Selesai"
                              data-vv-name="tgl_berlaku_akhir"
                              data-vv-as="Tanggal Selesai"
                              v-validate="'required'"
                              :min="organisasi.tgl_berlaku_awal"
                              :error-messages="errors.collect('form.tgl_berlaku_akhir')"
                            ></m-datepicker>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                            <label class="caption">Total Kuota</label>
                            <v-text-field
                              dense
                              single-line
                              outlined
                              label="Total Kuota"
                              v-model="organisasi.kuota"
                              hint="Total Kuota"
                              data-vv-name="kuota"
                              data-vv-as="Total Kuota"
                              type="number"
                              v-validate="'required'"
                              :error-messages="errors.collect('form.kuota')"
                            ></v-text-field>
                          </v-col>
                        </template>
                        <template v-else>
                          <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                            <label class="caption">Total Kuota</label>
                            <v-text-field
                              dense
                              single-line
                              outlined
                              label="Total Kuota"
                              v-model="organisasi.kuota"
                              hint="Total Kuota"
                              data-vv-name="kuota"
                              data-vv-as="Total Kuota"
                              type="number"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <v-alert text dense color="blue" icon="mdi-information-outline" border="left">
                              <b>Catatan: </b><br />
                              Jika kuota diisi, maka kuota user yang bisa ditambahkan di organisasi ini. Dibatasi sesuai
                              jumlah kuota yang diinputkan. Namun, apabila tidak diisikan (dibiarkan kosong) kuotanya
                              akan mengurangi kuota tenant
                            </v-alert>
                          </v-col>
                        </template>
                        <v-col cols="12" sm="12" md="12" xl="12" lg="12">
                          <v-toolbar flat>
                            <v-toolbar-title>
                              <v-btn depressed text color="primary" @click="e1 = 2">Kembali</v-btn>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn depressed color="primary darken-1" @click="validasiStep(4)">
                              Lanjut
                              <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                          </v-toolbar>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                      <v-row wrap justify-center>
                        <v-col cols="12" sm="12" md="12" xl="12" lg="12">
                          <p class="subtitle-1 font-weight-medium">
                            Apakah Anda akan menyimpan data organisasi sesuai konfigurasi yang Anda lakukan?
                          </p>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-card flat class="grey lighten-4">
                            <v-card-text>
                              <div class="text-h6 primary--text font-weight-medium">Identitas Organisasi</div>
                              <v-divider class="my-2"></v-divider>
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted">Nama Organisasi</div>
                                  <div class="black--text">{{ organisasi.nama || '' }}</div>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted">Surel</div>
                                  <div class="black--text">{{ organisasi.email || '' }}</div>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted">Nomor Telp</div>
                                  <div class="black--text">{{ organisasi.no_telp || '' }}</div>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted">Faximile</div>
                                  <div class="black--text">{{ organisasi.fax || '' }}</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12">
                                  <div class="text-muted">Alamat</div>
                                  <div class="black--text">{{ organisasi.alamat || '' }}</div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-card flat class="grey lighten-4">
                            <v-card-text>
                              <div class="text-h6 primary--text font-weight-medium">Informasi Tambahan</div>
                              <v-divider class="my-2"></v-divider>
                              <template v-if="arrayAtribut.length">
                                <v-simple-table class="grey lighten-4">
                                  <template v-slot:default>
                                    <thead class="grey lighten-4 font-weight-light">
                                      <tr>
                                        <th class="text-left">
                                          Nama Atribut
                                        </th>
                                        <th class="text-left">
                                          Isi Atribut
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(item, i) in arrayAtribut"
                                        :key="i"
                                        class="grey lighten-4 font-weight-light"
                                      >
                                        <td>{{ item.key }}</td>
                                        <td>{{ item.value }}</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </template>
                              <template v-else>
                                <div class="text-center">
                                  Atribut tidak di isikan
                                </div>
                              </template>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-card flat class="grey lighten-4">
                            <v-card-text>
                              <div class="text-h6 primary--text font-weight-medium">Informasi Kuota</div>
                              <v-divider class="my-2"></v-divider>
                              <v-row>
                                <template v-if="current_user.is_super_admin === 1">
                                  <v-col cols="12" md="6" sm="12">
                                    <div class="text-muted">Tanggal Mulai</div>
                                    <div class="black--text">{{ organisasi.tgl_berlaku_awal | toSD }}</div>
                                  </v-col>
                                  <v-col cols="12" md="6" sm="12">
                                    <div class="text-muted">Tanggal Selesai</div>
                                    <div class="black--text">{{ organisasi.tgl_berlaku_akhir | toSD }}</div>
                                  </v-col>
                                </template>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted">Kuota</div>
                                  <div class="black--text">{{ organisasi.kuota || '0' }}</div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col
                          v-if="!organisasi.organisasi_id && current_user.is_super_admin === 1"
                          cols="12"
                          sm="12"
                          md="12"
                          xl="12"
                          lg="12"
                        >
                          <v-alert text dense color="blue" icon="mdi-information-outline" border="left">
                            <div>
                              <div> Apakah anda ingin menggunakan pengaturan tenant untuk organisasi berikut ? </div>
                              <div> Data yang akan mengikuti pengaturan dari tenant </div>
                              <ul>
                                <li>Data Periode</li>
                                <li>Data Keterlambatan (Skor Presensi)</li>
                                <li>Jam Kerja</li>
                                <li>Hari Libur</li>
                                <li>Kategori Cuti</li>
                              </ul>
                            </div>
                            <v-checkbox
                              v-model="organisasi.is_pengaturan_tenant"
                              value="1"
                              label="Ya, saya ingin menggunakan pengaturan tenant"
                            >
                            </v-checkbox>
                          </v-alert>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="d-flex justify-space-between mt-5">
                          <v-btn depressed text color="primary" @click="e1 = 3">Kembali</v-btn>
                          <v-btn name="simpan" depressed color="primary" @click="save">
                            <v-icon>mdi-check</v-icon>Simpan
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>

    <v-form @submit.prevent data-vv-scope="form" lazy-validation></v-form>
  </m-dialog>
</template>

<script>
export default {
  props: {
    tenant: {
      default: () => {},
    },
  },

  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      edited: null,
      paths: [[]],
      e1: 0,
      arrayAtribut: [
        {
          id: 1,
          key: null,
          value: null,
        },
      ],
      arrayAlamat: [
        {
          id: 1,
          key: null,
          value: null,
        },
      ],
      places: [],
      currentPlace: null,
      roles: [],
      organisasi: {},
      defOrganisasi: {
        nama: null,
        latitude: null,
        longitude: null,
        alamat: null,
        kode_tenant: null,
        no_telp: null,
        tgl_berlaku_awal: null,
        tgl_berlaku_akhir: null,
        kuota: '',
      },
    }
  },
  computed: {
    // center() {
    //   //jarak pelebaran kordinat
    //   let meters = 30;
    //   // 1km dalam derajat = 1 / 111.32km = 0.0089
    //   // 1m dalam derajat = 0.0089 / 1000 = 0.0000089
    //   let coef = meters * 0.0000089;
    //   //kordinat latitude baru
    //   let new_lat = parseFloat(this.organisasi.latitude) + coef;
    //   //kordinat latitude baru
    //   let new_long =
    //     parseFloat(this.organisasi.longitude) +
    //     coef / Math.cos(parseFloat(this.organisasi.latitude) * (Math.PI / 180));
    //   //setting default path
    //   let a = [
    //     {
    //       lat: parseFloat(this.organisasi.latitude),
    //       lng: parseFloat(this.organisasi.longitude)
    //     },
    //     { lat: parseFloat(this.organisasi.latitude), lng: new_long },
    //     { lat: new_lat, lng: new_long },
    //     { lat: new_lat, lng: parseFloat(this.organisasi.longitude) }
    //   ];
    //   return {
    //     lat: parseFloat(this.organisasi.latitude),
    //     lng: parseFloat(this.organisasi.longitude),
    //     paths: a
    //   };
    // },
    // markers() {
    //   return [{ position: this.center }];
    // }
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.e1 = 1
      this.$validator.reset()
      this.organisasi = obj ? { ...obj } : { ...this.defOrganisasi }
      if (obj) {
        this.arrayAtribut = obj.atribut || []
        if (obj.tgl_berlaku_awal || obj.tgl_berlaku_akhir) {
          this.organisasi.tgl_berlaku_awal = (obj.tgl_berlaku_awal || '').substr(0, 10)
          this.organisasi.tgl_berlaku_akhir = (obj.tgl_berlaku_akhir || '').substr(0, 10)
        }
      }

      return this.$refs.dlg.open()
    },
    // updateEdited(mvcArray) {
    //   let paths = [];
    //   for (let i = 0; i < mvcArray.getLength(); i++) {
    //     let path = [];
    //     for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
    //       let point = mvcArray.getAt(i).getAt(j);
    //       path.push({ lat: point.lat(), lng: point.lng() });
    //     }
    //     paths.push(path);
    //   }
    //   this.edited = paths;
    // },
    add(a) {
      this.arrayAtribut.push({
        id: a + 1,
        key: null,
        value: null,
      })
    },
    remove(index) {
      this.arrayAtribut.splice(index, 1)
    },
    validasiStep(step) {
      if (step === 4 && this.current_user && this.current_user.is_super_admin === 1) {
        const kuota = (this.tenant && this.tenant.kuota && this.tenant.kuota.kuota)
        if (![undefined, null].includes(kuota)) {
          if (Number(this.organisasi.kuota) > kuota) {
            this.$error(`Kuota organisasi melebihi kuota tenant yaitu ${kuota} kuota`)
            return
          }
        }
      }

      this.$validator.validateAll('form').then((res) => {
        if (!res) return Promise.reject()
        this.e1 = step
        return this.e1
      })
    },
    // receives a place object via the autocomplete component
    // setPlace(place) {
    //   this.currentPlace = place;
    // },
    // addMarker() {
    //   if (this.currentPlace) {
    //     const marker = {
    //       lat: this.currentPlace.geometry.location.lat(),
    //       lng: this.currentPlace.geometry.location.lng()
    //     };
    //     this.markers.push({ position: marker });
    //     this.places.push(this.currentPlace);
    //     this.center = marker;
    //     this.currentPlace = null;
    //     this.organisasi.latitude = this.currentPlace.geometry.location.lat();
    //     this.organisasi.longitude = this.currentPlace.geometry.longitude.lat();
    //   }
    // },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          this.organisasi.atribut = this.arrayAtribut
          // this.organisasi.paths = this.edited;
          if (!this.organisasi.kode_tenant) {
            this.organisasi.kode_tenant = this.current_user.kode_tenant
              ? this.current_user.kode_tenant
              : this.current_organisasi.kode_tenant
          }

          return this.$store.dispatch('organisasi/form', this.organisasi)
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$info('Simpan Data Berhasil')
            this.$refs.dlg.resolve()
            return res
          } else {
            this.$error('Simpan Data Gagal')
            this.$refs.dlg.resolve()
          }
        })
        .catch((e) => e)
    },
  },
}
</script>
